import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6503851f")

_pushScopeId("data-v-6503851f")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content custom-kn-page-width p-d-flex p-flex-column" }
const _hoisted_3 = { class: "p-d-flex custom-overflow-parent-container" }
const _hoisted_4 = { class: "p-d-flex p-ai-center p-jc-between custom-overflow-auto" }
const _hoisted_5 = { class: "p-d-flex p-mx-2" }
const _hoisted_6 = {
  for: "startDate",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_7 = { class: "p-d-flex p-ai-center p-mx-2" }
const _hoisted_8 = {
  for: "startTime",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_9 = { class: "p-d-flex p-mx-2" }
const _hoisted_10 = {
  for: "endDate",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_11 = { class: "p-d-flex p-ai-center p-mx-2" }
const _hoisted_12 = {
  for: "endTime",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_13 = { class: "custom-timepicker" }
const _hoisted_14 = { class: "p-d-flex p-ai-center p-mx-2" }
const _hoisted_15 = { class: "p-d-flex p-flex-column" }
const _hoisted_16 = {
  for: "package",
  class: "kn-material-input-label"
}
const _hoisted_17 = { class: "p-d-flex p-ai-center p-mx-2" }
const _hoisted_18 = { class: "p-d-flex p-flex-column" }
const _hoisted_19 = {
  for: "document",
  class: "kn-material-input-label"
}
const _hoisted_20 = { class: "p-d-flex p-ai-center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h1", null, null, -1)
const _hoisted_22 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "p-col-12 p-sm-12 p-md-12 p-p-0 p-d-flex p-flex-column flex-container-overflow-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_SchedulationAgendaDialog = _resolveComponent("SchedulationAgendaDialog")
  const _component_Card = _resolveComponent("Card")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.title')), 1)
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar",
            "data-test": "progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", {
        style: _ctx.schedulationAgendaDescriptor.hCard.style,
        class: "card-no-padding flex-no-resize p-p-3"
      }, [
        _createVNode(_component_Card, null, {
          content: _withId(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.detail.startDate') + ':'), 1),
                  _createVNode("span", null, [
                    _createVNode(_component_Calendar, {
                      id: "startDate",
                      class: "kn-material-input",
                      modelValue: _ctx.startDateTime,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDateTime = $event)),
                      showIcon: true,
                      manualInput: false,
                      minDate: _ctx.minStartDate,
                      "data-test": "start-date"
                    }, null, 8, ["modelValue", "minDate"])
                  ])
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.detail.startTime') + ':'), 1),
                  _createVNode("span", null, [
                    _createVNode(_component_Calendar, {
                      id: "startTime",
                      class: "kn-material-input custom-timepicker",
                      modelValue: _ctx.startDateTime,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.startDateTime = $event)),
                      manualInput: false,
                      timeOnly: true,
                      hourFormat: "24",
                      inline: true,
                      "data-test": "start-time"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.detail.endDate') + ':'), 1),
                  _createVNode("span", null, [
                    _createVNode(_component_Calendar, {
                      id: "endDate",
                      class: "kn-material-input",
                      modelValue: _ctx.endDateTime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.endDateTime = $event)),
                      showIcon: true,
                      manualInput: false,
                      "data-test": "end-date"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.detail.endTime') + ':'), 1),
                  _createVNode("span", _hoisted_13, [
                    _createVNode(_component_Calendar, {
                      id: "endTime",
                      class: "kn-material-input",
                      modelValue: _ctx.endDateTime,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.endDateTime = $event)),
                      manualInput: false,
                      timeOnly: true,
                      hourFormat: "24",
                      inline: true,
                      "data-test": "end-time"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.detail.package')), 1),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.selectedPackageName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedPackageName = $event)),
                      id: "package",
                      class: "kn-material-input",
                      type: "text",
                      "data-test": "package-input",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showForm('packageForm'))),
                      readonly: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-external-link-alt",
                    class: "p-button-text p-button-rounded p-button-plain",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showForm('packageForm')))
                  }),
                  (_ctx.selectedPackage)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-times-circle",
                        class: "p-button-text p-button-rounded p-button-plain",
                        onClick: _ctx.removeSelectedPackage
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.detail.document')), 1),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.selectedDocumentName,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedDocumentName = $event)),
                      id: "document",
                      class: "kn-material-input",
                      type: "text",
                      "data-test": "document-input",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showForm('documentForm'))),
                      readonly: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-external-link-alt",
                    class: "p-button-text p-button-rounded p-button-plain",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showForm('documentForm')))
                  }),
                  (_ctx.selectedDocument)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-times-circle",
                        class: "p-button-text p-button-rounded p-button-plain",
                        onClick: _ctx.removeSelectedDocument
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", null, [
                    _createVNode(_component_Button, {
                      class: "p-button-text kn-button",
                      label: _ctx.$t('common.search'),
                      onClick: _ctx.runSearch,
                      "data-test": "search-button"
                    }, null, 8, ["label", "onClick"])
                  ])
                ]),
                _hoisted_21
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              (_ctx.displayFormType == 'packageForm')
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    _createVNode(_component_SchedulationAgendaDialog, {
                      itemList: _ctx.packageList,
                      model: _ctx.selectedPackage,
                      title: _ctx.$t('managers.schedulationAgendaManagement.packageTypes.title'),
                      onChanged: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedPackageChanged($event))),
                      onClose: _ctx.closeForm,
                      "data-test": "package-schedulation-form"
                    }, null, 8, ["itemList", "model", "title", "onClose"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.displayFormType == 'documentForm')
                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                    _createVNode(_component_SchedulationAgendaDialog, {
                      itemList: _ctx.documentList,
                      model: _ctx.selectedDocument,
                      title: _ctx.$t('managers.schedulationAgendaManagement.documentTypes.title'),
                      onChanged: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedDocumentChanged($event))),
                      onClose: _ctx.closeForm,
                      "data-test": "document-schedulation-form"
                    }, null, 8, ["itemList", "model", "title", "onClose"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ], 4),
      _createVNode("div", _hoisted_25, [
        _createVNode(_component_router_view, { itemList: _ctx.schedulations }, null, 8, ["itemList"])
      ])
    ])
  ]))
})